var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJlr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31589 28.1726C3.29311 26.9184 4.59701 24.6472 4.59701 22.191L4.59569 0H2.04571V22.0869C2.04571 23.0043 1.83321 23.8734 1.40131 24.5973C1.03627 25.1629 0.556093 25.6783 -0.000488281 26.0581L1.31562 28.1728L1.31589 28.1726Z",
    fill: "#23201F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3482 21.3381V0H9.79822V23.8225H24.0783L22.5484 21.3381H12.3482Z",
    fill: "#23201F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2519 6.56815C31.2519 2.8928 28.0559 0 24.4517 0H17.5496V2.4844H24.4856C26.8998 2.4844 28.6337 4.3562 28.6337 6.56815C28.6337 8.78011 26.8998 10.7541 24.4856 10.7541H17.5156V13.2385H22.6835L29.2794 23.8225H31.9995L25.3696 13.1706C28.5995 12.7622 31.2516 10.2778 31.2516 6.56842L31.2519 6.56815Z",
    fill: "#23201F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28.1725,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJlr);
export default __webpack_public_path__ + "static/media/JLR.d5ec5ec27f8097e113fb14e9a9302788.svg";
export { ForwardRef as ReactComponent };